/**
 * Supplier service for API calls.
 * @typedef {import('../models/Supplier').Supplier} Supplier
 * @typedef {import('../models/Supplier').SupplierCreate} SupplierCreate
 * @typedef {import('../models/Supplier').SupplierUpdate} SupplierUpdate
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const getSuppliers = async (accessToken) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/suppliers`, {
      headers: authHeaders(accessToken)
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to get suppliers');
  }
};

export const getSupplier = async (accessToken, supplierId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/suppliers/${supplierId}`, {
      headers: authHeaders(accessToken)
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to get supplier');
  }
};

export const createSupplier = async (accessToken, data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/suppliers`,
      { supplier: data },
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to create supplier');
  }
};

export const updateSupplier = async (accessToken, supplierId, data) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/suppliers/${supplierId}`,
      { supplier: data },
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to update supplier');
  }
};

export const deleteSupplier = async (accessToken, supplierId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/api/suppliers/${supplierId}`, {
      headers: authHeaders(accessToken)
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to delete supplier');
  }
};
